import { useMemo } from 'react'
import { CoInfoDocumentDepositAssignedFragment } from 'src/api/api.generated'
import { ReferenceType } from './deposit-split.types'
import useLocalizeString from 'src/app/hooks/current-locale/use-localized-string'
import { DepositSplitRow } from './deposit-split-grid/deposit-split.types'
import { DepositSplit } from './deposit-split'
import { useTranslation } from 'react-i18next'

export const DepositSplitDataWrapper = (props: { propertyId: string; documentId: string; loading: boolean; data: CoInfoDocumentDepositAssignedFragment[] }) => {
  const localizeString = useLocalizeString()
  const { t } = useTranslation()

  const getReference = (
    inputData: CoInfoDocumentDepositAssignedFragment,
  ): { billId?: string; reservationId?: string; reservedResourceId?: string; description: string; type: ReferenceType } | undefined => {
    if (inputData.bill) {
      return { billId: inputData.bill.id, reservationId: inputData.reservation?.id, reservedResourceId: inputData.reservedResource?.id, description: inputData.bill.description, type: 'bill' }
    }
    if (inputData.reservedResource && inputData.reservation) {
      const { assignedResourceType, resource } = inputData.reservedResource.resourceOccupancies[inputData.reservedResource.resourceOccupancies.length - 1]
      const description = `${resource?.code ?? assignedResourceType.code ?? localizeString(assignedResourceType.customName) ?? localizeString(assignedResourceType.name.description)} ${t(
        'pms.accounting.documents.deposit_split.reference_type_reservation',
      )} ${inputData.reservation.reservationCode}`
      return { reservedResourceId: inputData.reservedResource.id, reservationId: inputData.reservation.id, description, type: 'reservedResource' }
    }
    if (inputData.reservation) {
      return { reservationId: inputData.reservation.id, description: inputData.reservation.reservationCode, type: 'reservation' }
    }
  }

  const depositAssignedsToDepositSplit = (inputData: CoInfoDocumentDepositAssignedFragment[]): DepositSplitRow[] => {
    try {
      const outData = inputData.map<DepositSplitRow>((i) => {
        const result = getReference(i)
        if (result) {
          const { billId, reservationId, reservedResourceId, description, type } = result
          return {
            id: i.id,
            amount: i.amount,
            currency: i.currency,
            documentReferenceId: i.documentId,
            documentReferenceDescription: i.document?.numberExtended,
            reference: {
              type,
              description,
              billId,
              reservationId,
              reservedResourceId,
            },
          }
        } else {
          throw new Error('Deposit assigned does not contain any reference')
        }
      })
      return outData
    } catch (error) {
      console.error(error)
      return []
    }
  }

  const depositAssigneds = useMemo(() => {
    return depositAssignedsToDepositSplit(props.data)
  }, [props.data])

  return (
    <>
      {depositAssigneds && (
        <DepositSplit //
          propertyId={props.propertyId}
          data={depositAssigneds.filter((i) => !i.documentReferenceId)}
          usedQuotas={depositAssigneds.filter((i) => i.documentReferenceId)}
          depositDocumentId={props.documentId}
          loading={props.loading}
        />
      )}
    </>
  )
}
